export default "__VITE_ASSET__72a8eba5__"